import { render, staticRenderFns } from "./ChunkUploadPhp.vue?vue&type=template&id=6f2487cf"
import script from "./ChunkUploadPhp.vue?vue&type=script&lang=js"
export * from "./ChunkUploadPhp.vue?vue&type=script&lang=js"
import style0 from "./ChunkUploadPhp.vue?vue&type=style&index=0&id=6f2487cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports